<!-- Container-fluid starts-->
<div class="container-fluid">

  <div class="card">
    <div class="card-header">
      <h5>Settings</h5>
      <span>Setting the engine method of selecting offers for lockers</span>
    </div>
    <div class="card-body megaoptions-border-space-sm">
      <form class="mega-inline">
        <div class="row">
          <div class="col-lg-4 col-md-4 col-12">
            <div class="card {{mode1color}}">
              <div class="media p-20">
                <div class="radio radio-primary mr-3">
                  <input type="radio" name="radio1" id="radioMode1" value=1 [checked]="checkMode1" (change)="onChange($event)">
                  <label for="radioMode1"></label>
                </div>
                <div class="media-body custom-slider">
                  <h6 class="mt-0 mega-title-badge">Mode 1</h6>
                  <p>Offers are sorted based on algorithm use Advertiser rating and always 60% offers are from top list of with short term EPC count in days</p>
                  <ngx-slider [(value)]="epcInDays" [options]="SliderOptionsEPC" (mouseup)="onChangeSlider()">
                  </ngx-slider>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-4 col-12">
            <div class="card {{mode2color}}">
              <div class="media p-20">
                <div class="radio radio-secondary mr-3">
                  <input type="radio" name="radio1" id="radioMode2" value=2 [checked]="checkMode2" (change)="onChange($event)">
                  <label for="radioMode2"></label>
                </div>
                <div class="media-body">
                  <h6 class="mt-0 mega-title-badge">Mode 2</h6>
                  <p>Offers are sorted based on counting algorithm with EPC and Advertiser rating and presented in rolling window</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-4 col-12">
            <div class="card {{mode3color}}">
              <div class="media p-20">
                <div class="radio radio-secondary mr-3">
                  <input type="radio" name="radio1" id="radioMode3" value=3 [checked]="checkMode3" (change)="onChange($event)">
                  <label for="radioMode3"></label>
                </div>
                <div class="media-body">
                  <h6 class="mt-0 mega-title-badge">Mode 3</h6>
                  <p>Offers are sorted based on counting algorithm with EPC and Advertiser rating and always 60% offers are from top list</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>

    <admin-offers-topoffers></admin-offers-topoffers>
  </div>

</div>
<!-- Container-fluid Ends-->
